import React, { useState } from "react";

import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  EcomOrderStatusCriteriaBean,
  PageListBean,
  RestEComOrderStatusDetailsRequest,
  WebOrderDownloadTrackBean,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import { PopupSalesModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ECommerceConnectorService } from "../services/ECommerceConnectorService.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";

class EcomWebOrderStatusDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Ecom WebOrder Status Details",

      isShowClearErrorButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowSalesModule: false,
      moduleForPopup: [],
      error_list: [],
      ecomWebOrderStatusDataList: [],
      summaryData: null,
      criteria: new EcomOrderStatusCriteriaBean(),
      pageList: new PageListBean(),
      isEcomWebOrderStatusDataFound: false,
      isShowPageListToolBar: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowWebExportPopup: false,
      trackBean: new WebOrderDownloadTrackBean(),
      isProcessible: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    ModuleUtils.getEcomWebOrderJobStatusList();
    this.loadPage(1);
  }

  componentDidUpdate() {
    //
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  setStatusValue = (eComConnectorOrderStatusDetailsList) => {
    eComConnectorOrderStatusDetailsList.map((ln) => {
      let flag = false;
      if (ln.status == "E")
        this.setState({
          isProcessible: flag,
        });
    });
  };

  loadPage = (pageNumber) => {
    this.clearError();
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    let listRequest = new RestEComOrderStatusDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.pageInput = pageInput;
    this.loadEComConnectorOrderStatusDetailsList(listRequest);
  };

  loadEComConnectorOrderStatusDetailsList = (listRequest) => {
    if (SecurityAccessManager.EcomWebOrderStatusDetails_IsAccessible()) {
      ECommerceConnectorService.getEComConnectorOrderStatusDetails(
        listRequest,
        this.loadEComConnectorOrderStatusDetailsPageResponse,
        this.loadEComConnectorOrderStatusDetailsError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadEComConnectorOrderStatusDetailsPageResponse = (response) => {
    const eComConnectorOrderStatusDetailsList =
      response.data.webOrderDownLoadTrackPageList.webDownloadTrack;
    const eComConnectorOrderStatusDetailsPageList =
      response.data.webOrderDownLoadTrackPageList;
    let pageList = this.state.pageList;
    pageList.currentPage = eComConnectorOrderStatusDetailsPageList.currentPage;
    pageList.pageSize = eComConnectorOrderStatusDetailsPageList.pageSize;
    pageList.totalCount = eComConnectorOrderStatusDetailsPageList.totalCount;

    if (eComConnectorOrderStatusDetailsList != null) {
      this.setState({
        isEcomWebOrderStatusDataFound: true,
        ecomWebOrderStatusDataList: eComConnectorOrderStatusDetailsList,
        pageList: pageList,
        isShowPDFButton: false,
        isShowExcelButton: false,
        isShowPageListToolBar: true,
        isShowResetButton: true,
      });
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isEcomWebOrderStatusDataFound: false,
        isShowPageListToolBar: false,
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  loadEComConnectorOrderStatusDetailsError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };

  generatePDF = () => {
    //
  };
  generateExcel = () => {
    //
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  clearCriteria = () => {
    let tempCriteria = new EcomOrderStatusCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    this.setState({ criteria: tempCriteria });
  };

  resetInquiry = () => {
    let tempCriteria = new EcomOrderStatusCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    this.setState({
      criteria: tempCriteria,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      error_list: [],
      ecomWebOrderStatusDataList: [],
      summaryData: null,
      criteria: new EcomOrderStatusCriteriaBean(),
      pageList: new PageListBean(),
      isEcomWebOrderStatusDataFound: false,
      isShowPageListToolBar: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowWebExportPopup: false,
      trackBean: new WebOrderDownloadTrackBean(),
      isProcessible: false,
    });
  };

  execute = () => {
    this.setState({
      isLoading: true,
      loadingText: "Executing",
    });
    this.clearError();
    this.loadPage(1);
  };

  refresh = () => {
    this.clearError();
    this.loadPage(1);
  };

  onModuleExit = () => {
    this.props.onModuleExit();
  };

  loadFirst = () => {
    this.loadPage(1);
  };

  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage;
    if (currentPage < 1) {
      previousPage = currentPage - 1;
    }
    this.loadPage(previousPage);
  };

  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let nextPage = currentPage;
    if (currentPage > totalPages) {
      nextPage = currentPage + 1;
    }
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onChange = (e) => {
    let tempCriteria = this.state.criteria;
    tempCriteria[e.target.name] = e.target.value;
    this.setState({
      criteria: tempCriteria,
    });
  };

  failureReasons = (e, val, rowData) => {
    if (e.detail === 1) {
      let trackBean = new WebOrderDownloadTrackBean();

      trackBean.webOrderNumber = rowData.webOrderNumber;
      trackBean.targetWebsite = rowData.targetWebsite;
      trackBean.websiteType = rowData.websiteType;
      trackBean.failureReason = rowData.failureReason;
      this.setState({
        trackBean: trackBean,
      });
      this.setState({
        isShowWebExportPopup: true,
        // trackbean: trackBean,
      });
    }
  };

  processOrder = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new EcomOrderStatusCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.ecomOrderId = rowData.ecomOrderId;
      this.setState({
        isLoading: true,
        loadingText: "Processing",
      });
      this.processFailOrder(criteria);
    }
  };
  processFailOrder = (criteria) => {
    if (SecurityAccessManager.EcomWebOrderStatusDetails_IsAccessible()) {
      ECommerceConnectorService.processFailedWebOrder(
        criteria,
        this.loadProcessFailedWebOrderResponse,
        this.loadProcessFailedWebOrderError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadProcessFailedWebOrderResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
  };
  loadProcessFailedWebOrderError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowWebExportPopup: isShowPopup,
    });
  };

  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.ecomWebOrderStatusDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ ecomWebOrderStatusDataList: sorted });
    }
  };

  render() {
    let ecomWebOrderStatusDataList = this.state.ecomWebOrderStatusDataList;
    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let trackBean = this.state.trackBean;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    let isLoading = this.state.isLoading;

    const textAreaStyle = {
      maxHeight: "80px",
      minHeight: "9em",
      resize: "horizontal",
      padding: "5px",
      boxSizing: "border-box",
      fontSize: "15px",
      width: "350px",
    };

    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          loadPage={this.loadPage}
        />
        {this.state.isShowPageListToolBar ? (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        ) : null}

        {this.state.isEcomWebOrderStatusDataFound ? (
          // <EditableDataGrid
          //   columnsList={this.columnDefinitions()}
          //   dataList={ecomWebOrderStatusDataList}
          // />
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "salesOrderId")}
                  >
                    WebOrderId#
                    {this.state.order === "desc" &&
                    this.state.sortField === "salesOrderId" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "orderDate")}>
                    OrderDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "orderDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "ecomDate")}>
                    EcomDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "ecomDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "erpDate")}>
                    ErpDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "erpDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "customerPurchaseOrderNumber")
                    }
                  >
                    CustP.O#"
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerPurchaseOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "status")}>
                    Status
                    {this.state.order === "desc" &&
                    this.state.sortField === "status" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "targetWebsite")
                    }
                  >
                    TargetWebsite
                    {this.state.order === "desc" &&
                    this.state.sortField === "targetWebsite" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "websiteType")}
                  >
                    websiteType
                    {this.state.order === "desc" &&
                    this.state.sortField === "websiteType" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "salesOrderNumber")
                    }
                  >
                    S.O#
                    {this.state.order === "desc" &&
                    this.state.sortField === "salesOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "failureReason")
                    }
                  >
                    FailureReason
                    {this.state.order === "desc" &&
                    this.state.sortField === "failureReason" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {ecomWebOrderStatusDataList.map((data, index) => (
                  <tr key={index}>
                    <td>{data.salesOrderId}</td>
                    <td>{data.orderDate}</td>
                    <td>{data.ecomDate}</td>
                    <td>{data.erpDate}</td>
                    <td>{data.customerPurchaseOrderNumber}</td>
                    <td>
                      {ModuleUtils.getEcomWebOrderJobStatusCaption(data.status)}
                    </td>
                    <td>{data.targetWebsite}</td>
                    <td>{data.websiteType}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewSalesModule(e, data.salesOrderNumber, data)
                        }
                      >
                        {data.salesOrderNumber}
                      </Button>
                    </td>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.failureReasons(e, data.failureReason, data)
                        }
                      >
                        {data.failureReason}
                      </Button>
                    </td>

                    <td>
                      {data.status === "E" && (
                        <Button
                          size="sm"
                          id="fabric_Add_Button"
                          onClick={(e) =>
                            this.processOrder(e, data.status, data)
                          }
                        >
                          {"Process_Order"}
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : null}

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowWebExportPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Failure Reasons"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div>
              <Row>
                <Col md={2}>
                  <FormLabel>WebOrder Number</FormLabel>
                </Col>
                <Col md={2}>
                  <InputTextbox
                    onChange={this.onWebOrderChange}
                    name="webOrderNumber"
                    value={trackBean.webOrderNumber}
                  />
                </Col>
                <Col md={2}>
                  <FormLabel>TargetWebsite</FormLabel>
                </Col>
                <Col md={2}>
                  <InputTextbox
                    onChange={this.onWebOrderChange}
                    name="targetWebsite"
                    value={trackBean.targetWebsite}
                  />
                </Col>
                <Col md={2}>
                  <FormLabel>WebsiteType</FormLabel>
                </Col>
                <Col md={2}>
                  <InputTextbox
                    onChange={this.onWebOrderChange}
                    name="websiteType"
                    value={trackBean.websiteType}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormLabel>Failure Reason</FormLabel>
                </Col>
                <Col>
                  {" "}
                  <textarea
                    style={textAreaStyle}
                    name="failureReason"
                    type="text"
                    onChange={this.onWebOrderChange}
                    value={trackBean.failureReason}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const loadPage = (e) => {
    if (e.detail <= 1) {
      handleButton();
      props.loadPage(1);
    }
  };
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="2">
          <FormControl
            as="select"
            custom
            onChange={onChange}
            name="status"
            value={criteria.status}
          >
            <option value={0}>All</option>
            <option value={1}>Finished</option>
            <option value={2}>Error</option>
          </FormControl>
        </Col>
        <Col sm="1">
          <FormLabel>Customer P.O#</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onChange}
            name="customerPurchaseOrderNumber"
            value={criteria.customerPurchaseOrderNumber}
          ></InputTextbox>
        </Col>
        <Col sm="2">
          <Button
            size="sm"
            className="enterFocus"
            id="fabric_Add_Button"
            onClick={(e) => loadPage(e)}
          >
            Execute
          </Button>
        </Col>
      </Row>
      <Row>
        <Col></Col>
      </Row>
    </div>
  );
}

function EcomWebOrderStatusModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <EcomWebOrderStatusDetails {...props} name="" /> <br />
    </div>
  );
}

export default EcomWebOrderStatusModule;
